import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/product/correct.svg'


const _withScopeId = n => (_pushScopeId("data-v-48f942f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "popup_view" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "introduce" }
const _hoisted_4 = { class: "options" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

import provide_key from "@/constant/provide_key";
import { inject, computed } from "vue";
import { useRouter } from 'vue-router'
import routeHash from '@/constant/router_hash'
import Mitt from "@/utils/mitt";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupView',
  props: ["visible", "productInfo"],
  emits: ["update:visible"],
  setup(__props, { emit: __emit }) {


const emits = __emit;
const shrink: boolean | undefined = inject(provide_key.SHRINK);

const router = useRouter()

const onClose = () => emits("update:visible", false);

const onServer = () => {
  setTimeout(() => Mitt.emit(routeHash.CONTACT_US), 0)
  onClose()
  router.push({ path: "/company" })
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_dialog, {
      show: __props.visible,
      showConfirmButton: false,
      closeOnClickOverlay: true,
      width: "55vw"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "popup_content",
          style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row' })
        }, [
          _createVNode(_component_van_icon, {
            name: "cross",
            class: "close",
            onClick: onClose
          }),
          _createElementVNode("div", {
            class: "thumbnail",
            style: _normalizeStyle({'height': _unref(shrink) ? '20vh' : '40vh'})
          }, [
            _createElementVNode("img", {
              src: __props.productInfo.thumbnailLeft,
              alt: ""
            }, null, 8, _hoisted_2)
          ], 4),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productInfo.details, (detail, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "option",
                  key: index
                }, [
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(detail), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "button",
              onClick: onServer
            }, _toDisplayString(_ctx.$t('product.GET_MORE')), 1)
          ])
        ], 4)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})